var footerLinks = document.querySelectorAll(".footer-links a");

footerLinks.forEach(function (link) {
    if (link.getAttribute("data-faq")) {
        var sidebarFaq = link.getAttribute("data-faq");

        link.addEventListener("click", function () {
            localStorage.setItem("footer-click-faq", sidebarFaq);
        });
    }
});
